import { z } from "zod";

export const LoginUserSchema = z.object({
  login: z.string().min(0).max(32),
  password: z.string().min(8).max(32),
});
